<template>
  <router-view />
</template>

<script>
export default {
  name: 'AeeQuestionnaireWrapper',
};
</script>
